var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 7.00012C19.7 3.89575 17.2339 1.34032 14.1444 1.34033C11.055 1.34033 8.58887 3.89575 8.58887 7.00012C8.58887 10.1045 11.055 12.6599 14.1444 12.6599C17.2339 12.6599 19.7 10.1045 19.7 7.00012Z",
    fill: "#FF8E00",
    stroke: "#28293D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 7.00012C12.4109 3.89575 9.94481 1.34032 6.85536 1.34033C3.7659 1.34033 1.2998 3.89575 1.2998 7.00012C1.2998 10.1045 3.7659 12.6599 6.85536 12.6599C9.94482 12.6599 12.4109 10.1045 12.4109 7.00012Z",
    fill: "#FF8E00",
    stroke: "#28293D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.781de1dfb6a8424be121903c752679b6.svg";
export { ForwardRef as ReactComponent };